
  document.addEventListener("DOMContentLoaded", function () {
    function scrollToSection(selector) {
      const section = document.querySelector(selector);
      if (section) {
        section.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      }
    }

    document.addEventListener("click", function (e) {
      const productBtn = e.target.closest(".select-product-btn");
      if (productBtn) {
        scrollToSection("#shopify-section-template--16564456783927__variant_subscription_XdRkCW");
      }

      const variantBtn = e.target.closest(".select-variant-btn");
      if (variantBtn) {
        scrollToSection("#shopify-section-template--16564456783927__app_subscriptionss_Cxwraz");
      }

      const planBtn = e.target.closest(".select-plan-btn");
      if (planBtn) {
        scrollToSection("#shopify-section-template--16564456783927__order_details_xiNcQD");
      }
    });

    function observeSection(selector) {
      const section = document.querySelector(selector);
      if (!section) return;
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach(entry => {
            if (entry.isIntersecting) {
              console.log(" Visible:", selector);
              section.classList.add("highlight");
            } else {
              section.classList.remove("highlight");
            }
          });
        },
        { root: null, threshold: 0.2 }
      );
      observer.observe(section);
    }

    observeSection("#shopify-section-template--16564456783927__variant_subscription_XdRkCW");
    observeSection("#shopify-section-template--16564456783927__app_subscriptionss_Cxwraz");
    observeSection("#shopify-section-template--16564456783927__order_details_xiNcQD");
  });

  

